import AtriumApi from "api";

const heartbeatActionItemService = {
  // Get all action items with filtering/pagination
  getActionItems: async (params = {}) => {
    try {
      const response = await AtriumApi.get("/v2/heartbeat/action-items", { params });
      return response.data;
    } catch (error) {
      console.error("Error fetching action items:", error);
      throw error;
    }
  },

  // Get single action item by ID
  getActionItemById: async (id) => {
    try {
      const response = await AtriumApi.get(`/v2/heartbeat/action-items/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching action item:", error);
      throw error;
    }
  },

  // Get action items assigned to current user
  getMyActionItems: async (params = {}) => {
    try {
      const response = await AtriumApi.get("/v2/heartbeat/action-items/my-items", {
        params,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching my action items:", error);
      throw error;
    }
  },

  // Get action items for a specific guest user
  getActionItemsByUser: async (userId) => {
    try {
      const response = await AtriumApi.get(
        `/v2/heartbeat/action-items/by-user/${userId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching user action items:", error);
      throw error;
    }
  },

  // Get action item statistics
  getStats: async () => {
    try {
      const response = await AtriumApi.get("/v2/heartbeat/action-items/stats");
      return response.data;
    } catch (error) {
      console.error("Error fetching action item stats:", error);
      throw error;
    }
  },

  // Update action item (status, notes, etc.)
  updateActionItem: async (id, data) => {
    try {
      const response = await AtriumApi.put(`/v2/heartbeat/action-items/${id}`, data);
      return response.data;
    } catch (error) {
      console.error("Error updating action item:", error);
      throw error;
    }
  },

  // Assign action item to a staff member
  assignActionItem: async (id, assigneeId) => {
    try {
      const response = await AtriumApi.post(
        `/v2/heartbeat/action-items/${id}/assign`,
        { assigneeId }
      );
      return response.data;
    } catch (error) {
      console.error("Error assigning action item:", error);
      throw error;
    }
  },


  // Delete action item
  deleteActionItem: async (id) => {
    try {
      const response = await AtriumApi.delete(`/v2/heartbeat/action-items/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting action item:", error);
      throw error;
    }
  },

  // Get prayer requests
  getPrayerRequests: async (params = {}) => {
    try {
      const response = await AtriumApi.get("/v2/heartbeat/action-items/prayer-requests", { params });
      return response.data;
    } catch (error) {
      console.error("Error fetching prayer requests:", error);
      throw error;
    }
  },

  // Mark prayer request as answered
  markPrayerRequestAnswered: async (id, isAnswered = true) => {
    try {
      const response = await AtriumApi.put(`/v2/heartbeat/action-items/prayer-requests/${id}/mark-answered`, { isAnswered });
      return response.data;
    } catch (error) {
      console.error("Error marking prayer request:", error);
      throw error;
    }
  },
};

export default heartbeatActionItemService;
